export enum DialogType {
  Info,
  Alert,
  Confirm,
}
